// Styles for GiftCardsList go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledGiftCardsList = styled.div`
  .gift-card-wrapper {
    border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
  }

  .gift-card-image {
    width: ${toRem(96)};
    height: ${toRem(58)};
    border-radius: ${toRem(4)};
  }

  .gift-card-profile-image {
    width: ${toRem(48)};
    height: ${toRem(28)};
  }

  .gift-card-details {
    width: 100%;
  }

  .gift-card-number,
  .gift-card-expiry {
    color: ${baseVariables.color.neutral40};
  }

  .gift-card-amount {
    @media ${baseVariables.mediaQuery.md} {
      font-size: ${toRem(22)};
    }
  }

  .gift-card-number {
    @media ${baseVariables.mediaQuery.md} {
      font-size: ${toRem(16)};
    }
  }

  .giftCardRow {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    @media ${baseVariables.mediaQuery.md} {
      grid-template-columns: repeat(2, 1fr);
      gap: ${toRem(24)};
    }
  }

  .cardpin {
    gap: ${toRem(8)};
    margin-bottom: ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      margin-bottom: 0;
    }
  }

  .min-width-max-content {
    min-width: max-content;
  }

  // Badge overlay variants for gift card status
  .m-badge-overlay-neutral {
    background: rgba(28, 28, 28, 0.2);
    color: ${baseVariables.color['base10']};
    border-radius: 4px;
  }

  .card-expiring-icon {
    color: ${baseVariables.color['alert40']};
    &:before {
      font-size: ${toRem(16)};
    }
  }

  .card-expired-icon {
    color: ${baseVariables.color['alert50']};
    &:before {
      font-size: ${toRem(16)};
    }
  }

  .card-expiring-label {
    color: ${baseVariables.color['alert40']};
  }
  .card-expired-label {
    color: ${baseVariables.color['alert50']};
  }
`;
